import { useAgenticProcessStoreUpdate } from './agentic-process-store';
import type { AgenticProcessStore } from './agentic-process-store.type';

/**
 * Custom hook to easily access and update the agentic process store
 */
const useAgenticProcessStore = (): AgenticProcessStore => {
  const {
    selectedTab,
    setSelectedTab,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    setDateRange,
    selectedAgentSource,
    setSelectedAgentSource,
    selectedChartCategory,
    setSelectedChartCategory,
    selectedChartOptions,
    setSelectedChartOptions,
    selectedChartType,
    setSelectedChartType,
    viewBy,
    setViewBy,
    resetFinancialFilters,
  } = useAgenticProcessStoreUpdate();

  return {
    selectedTab,
    setSelectedTab,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    setDateRange,
    selectedAgentSource,
    setSelectedAgentSource,
    selectedChartCategory,
    setSelectedChartCategory,
    selectedChartOptions,
    setSelectedChartOptions,
    selectedChartType,
    setSelectedChartType,
    viewBy,
    setViewBy,
    resetFinancialFilters,
  };
};

export { useAgenticProcessStore };
